

$(document).ready(function(){
  $("#header-menu-mobile").click(function(){
    $("#header-menu-dropdown-mobile").slideToggle();
  });
  $("#header-search-mobile").click(function(){
    $("#header-search-dropdown-mobile").slideToggle();
  });

  $("#header-search-desktop").click(function(){
    $("#header-search-dropdown-desktop").slideToggle(function(){
      $("#header-search-dropdown-desktop").find(".header-search-bar").focus();
    });
  });

// $('.header-cart').on('click',function(){
//   $(".header-cart-con").toggleClass('show-cart');
// });

$("body").on("click",function(){
  if($(this).hasClass("close"))
  {
    $(".header-cart-con").removeClass('show-cart');
    $(this).removeClass("close");
  }
});

$(".global-cart-button").on("click",function(e){
  e.preventDefault();
  t = $(this);
  args = {quantity:1,id:t.prev().val()};
  console.log(args);
  t.html("Please wait");
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: args,
    dataType: 'json',
    error:function(){
     t.html("Buy");
     $.magnificPopup.open({
      items: {
        src: '#global-stock-message',
        type: 'inline'
      }
    });
   },
   success:function(line_item){

    $.ajax({
      url : '/cart.js',
      type : 'GET',
      dataType: 'json',
      success: function(cart){
        $(".header-cart-count").show().html(cart.item_count);
      }
    });

    $.get('/cart?view=json', function (cart, textStatus) {
      $(".header-cart-top-items-list").html(cart);
      $(".header-cart-con").addClass('show-cart');
      t.html("Buy");
      $("body").addClass("close");
    });
//  console.log(line_item);
//  img = line_item.image.replace(".jpg","_200x200_crop_center.jpg");
//  $(".header-cart-image-link .image").attr("src",img);
//  $(".header-cart-image-link").attr("href","/products/" + line_item.handle);
//  $(".header-cart-product-name").html(line_item.product_title).attr("href","/products/" + line_item.handle);
//  $(".header-cart-price").html(Shopify.formatMoney(line_item.price, money_format));
//  $(".header-cart-con").imagesLoaded(function(){
//   $(".header-cart-con").toggleClass('show-cart');
//   t.html("Buy");
//   setTimeout(function(){
//    $(".header-cart-con").removeClass('show-cart');
//  },4000);
// });


//location = "/cart";
}
});
});

$(".global-select-div-selection").change(function(){
  t = $(this);
  nn = t.find("option:selected").text();
  t.prev().text(nn);
});

$(".search-form").on("submit",function(){
  var dex = $(this).find(".header-search-bar").val();
  var lex = "";
  if (dex.trim() !== "") {      
    var lex = "*";
  }
  $(this).find('#q').val(dex+lex);
  return true;
});
});


